(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = 8;
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.baseUrl+".json?section_id=product-recommendations&limit="+limit+"&product_id="+productId; 
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var products = JSON.parse(request.response).products;
      if (products.length > 0) {
		_html ="<div class=\"owl-stage\">" + products.map(function(product) { return renderProduct(product) }).join("")+"</div>";
		//console.log(product);
      	document.getElementById("product-grid-2").innerHTML =  products.map(function(product) { return   renderProduct(product) }).join("")  ;
		jQuery(".owl-carousel").owlCarousel('destroy');
		jQuery(".owl-carousel").owlCarousel();
		//productRecommendationsSection.classList.remove("hide");
	  }
    }
  };
  request.send();
};
function renderProduct(product) {
	var price = formatMoney(product["price"]), 
		cprice = formatMoney(product["compare_at_price_max"]); 

	//console.log(product); 

	productStr = ""; 

	try {
    productStr = [
     
	  "<li class=\"grid-item\">", 
        "<div class=\"product-item instock__label label_style_2 normalCard\">",
  			"<div class=\"product-inner\">",
    			"<div class=\"product-thumb\">",
      				"<a href=\""+product["url"]+"\" class=\"LoopProduct-link\" title=\""+product["title"]+"\"></a><img src=\"//cdn.shopify.com/s/files/1/3005/1106/t/5/assets/bt_placeholder.svg?v=9629633953984904927\">",
					"<a class=\"front-image nonheight nonwidth_\" href=\""+product["url"]+"\" title=\""+product["title"]+"\">",
        				"<picture><img class=\" lazyloaded\" src=\""+product["images"][0]+"\" data-src=\""+product["images"][0]+"\" alt=\""+product["title"]+"\"></picture>",
      				"</a>",
      				"<div class=\"gorup-button\">",
						"<div class=\"button add_to_cart_button boutique__add-to-cart visible_5 visible_9 visible_7\" onclick=\"Shopify.KT_addItem('"+product["variants"][0]["id"]+"',1);$(this).addClass('loading').removeClass('loaded')\">Add to cart</div>",
						"<a href=\"javascript:void(0);\" class=\"compare\" data-pid=\""+product["handle"]+"\"><i class=\"icon-refresh\"></i></a>",
						"<a href=\"javascript:void(0);\" class=\"quick-view hidden_7\" data-view=\""+product["url"]+"\" data-target=\"#myModal\"><i class=\"icon-magnifier\"></i></a>",
					"</div>",
      				"<a href=\"javascript:void(0);\" class=\"quick-view visible_7\" data-view=\""+product["url"]+"\" data-target=\"#myModal\"><i class=\"icon-magnifier\"></i></a>",
					"<span class=\"price visible_9\"><ins class=\"ProductPrice-"+product["id"]+"\">$"+price+"</ins><del class=\"ComparePrice-"+product["id"]+" hidden\">$"+cprice+"</del></span>",
      				"<div class=\"add-cart-wapper visible_4_1 visible_8_1\"><div class=\"button add_to_cart_button boutique__add-to-cart visible_4_1_ visible_8_1_\" onclick=\"Shopify.KT_addItem('"+product["variants"][0]["id"]+"',1);$(this).addClass('loading').removeClass('loaded')\">Add to cart</div></div>",
				"</div>", 
				"<div class=\"product-info\">",
					"<h3 class=\"product-name\">",
						"<a href=\""+product["url"]+"\" title=\""+product["title"]+"\">"+product["title"]+"</a>",
					"</h3>",
					"<span class=\"price visible_9\"><ins class=\"ProductPrice-"+product["id"]+"\">$"+price+"</ins><del class=\"ComparePrice-"+product["id"]+" hidden\">$"+cprice+"</del></span>",
					"<div class=\"button add_to_cart_button boutique__add-to-cart hidden_4_1 hidden_5 hidden_8_1 hidden_9 hidden_7\" onclick=\"Shopify.KT_addItem('"+product["variants"][0]["id"]+"',1);$(this).addClass('loading').removeClass('loaded')\">Add to cart</div>",
				"</div>",
			"</div>",
		"</div>",
      "</li>"
    
    ].join("");

	} catch ($err) {
		console.log($err);
	}
	return productStr;
}
const moneyFormat = '${{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = ''; 
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break; 
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
